// extracted by mini-css-extract-plugin
export default {"underTitle":"underTitle_underTitle__WwPzk"};